'use client'

import lottiefile from '@/app/_components/Shared/LottiePlayer/champe_innie_idle.json'
import { Player } from '@lottiefiles/react-lottie-player'

export default function ChampeInniePlayer() {
  return <Player autoplay controls loop src={lottiefile} className="lg:w-201" />
}
